import { DELIVERY_STATUS_LIST } from "@constants/delivery";
import AppContext from "@helpers/context";
import { ViewLabelStatus } from "d-react-components";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

const DeliverySODetailHeader = () => {
  const { deliveryDetail } = useContext(AppContext);
  const { ref, status, by, created } = deliveryDetail ?? {};
  const { t } = useTranslation();

  return (
    <div className="card-container p-3 flex-center justify-content-between ">
      <div className="flex-column">
        <div className="d-flex">
          <h4>{ref}</h4>
          <ViewLabelStatus
            listStatus={DELIVERY_STATUS_LIST}
            status={status}
            className="ml-3"
            getLabel={(item) => t(item.label)}
          />
        </div>
      </div>
    </div>
  );
};

export default DeliverySODetailHeader;
